import type { MoonPayWebSdkInitFn, WindowMoonPayWebSdk } from '@web-sdk';

declare const window: Window & WindowMoonPayWebSdk;

export async function loadMoonPay(
  version: string | null = 'v1',
): Promise<MoonPayWebSdkInitFn | undefined> {
  return new Promise((resolve, reject) => {
    const scriptSrc = `https://static.moonpay.com/web-sdk/${version}/moonpay-web-sdk.min.js`;
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    if (existingScript) {
      const sdkConstructor = window.MoonPayWebSdk?.init;
      if (sdkConstructor) {
        resolve(sdkConstructor);
      } else {
        reject(new Error('MoonPayWebSdk failed to initialize.'));
      }
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://static.moonpay.com/web-sdk/${version}/moonpay-web-sdk.min.js`;

    script.addEventListener('load', () => {
      if (!window) {
        reject(
          new Error(
            "MoonPayWebSdk failed to initialize: no window object. Make sure you're calling this from the browser.",
          ),
        );
      }

      const sdkConstructor = window.MoonPayWebSdk?.init;
      if (!sdkConstructor) {
        reject(new Error('MoonPayWebSdk failed to initialize.'));
      }

      resolve(sdkConstructor);
    });

    script.addEventListener('error', () => {
      reject(new Error('Failed to load MoonPayWebSdk script.'));
    });

    document.body.appendChild(script);
  });
}
